import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { SmartHomeComponentsStore } from '@store';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { SmartHomeComponent } from '@vi-iot/client';
import { ActivatedRoute } from '@angular/router';
import { MatOptionSelectionChange } from '@angular/material/core';

@Component({
  selector: 'app-smart-home-components',
  templateUrl: './smart-home-components.component.html',
  styleUrls: ['./smart-home-components.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmartHomeComponentsComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject();
  installationId: number;

  smartHomeComponentsControl: FormControl<SmartHomeComponent[]> = new FormControl();
  smartHomeComponents: SmartHomeComponent[];

  constructor(
    public smartHomeComponentStore: SmartHomeComponentsStore,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((param) => {
      this.installationId = param['id'];
      this.smartHomeComponentStore.getSmartHomeComponents(this.installationId);
    });

    this.smartHomeComponentStore.smartHomeComponents$
      .pipe(
        filter((data) => !!data?.length),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((data) => {
        this.smartHomeComponentsControl.setValue(data.filter((item) => !!item.selected));
        this.smartHomeComponents = data;
        this.cdr.markForCheck();
      });
  }

  remove(element: SmartHomeComponent): void {
    element.selected = false;
    let currentValueArray = this.smartHomeComponentsControl.value;
    currentValueArray = currentValueArray.filter((item) => item.id !== element.id);
    this.smartHomeComponentsControl.setValue(currentValueArray);
  }

  save(): void {
    this.smartHomeComponentStore.updateSmartHomeComponents(
      this.installationId,
      this.smartHomeComponents
    );
  }

  select(event: MatOptionSelectionChange, item: SmartHomeComponent): void {
    if (event.isUserInput) {
      item.selected = event.source.selected;
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
